import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import defaultInstance from '../../axiosHelper';
import { API_ENDPOINTS } from '../../utils/apiEndPoints';

const VillageList = () => {
    const navigate = useNavigate();

    const headers = [
        'S.No',
        'Name of Village',
        'Village ID',
    ]

    const [villageOptions, setVillageOptions] = useState([])
    const [isLoading, setIsLoading] = useState(true);

    const fetchVillages = async () => {
        const response = await defaultInstance.get(API_ENDPOINTS.VILLAGE_LIST);
        setIsLoading(false)
        if (response?.data?.success) {
            const villages = response?.data?.data?.map(({ village_id, name }) => ({
                value: village_id,
                label: name,
            }));
            setVillageOptions(villages)
        }
    }

    useEffect(() => {
        setIsLoading(true)
        fetchVillages()
    }, [])

    if (isLoading) {
        return (<div style={{ width: '98vw', height: '95vh', position: 'absolute', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
            <img style={{ width: 50, height: 50 }} src='./loading.gif' alt='loading' />
        </div>)
    }

    return (
        <div className="role-container">
            <div className="filters-container">
                <button onClick={() => navigate(-1)} className="filter-button"><FaHome /> Home</button>
                <span style={{ fontSize: '35px' }}>VILLAGES LIST COVERED UNDER MIDORI-CMHA</span>
                <div style={{ opacity: 0 }} className="filter-container"></div>
            </div>
            <div
                style={{
                    marginTop: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                }}
                className="fm-item-container"
            >
                <table className="fm-item-table" style={{ width: '70%' }}>
                    <thead>
                        <tr>
                            {headers.map((th, idx) => (
                                <th key={idx} style={{ backgroundColor: '#217cc070' }}>
                                    {th}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {villageOptions?.map((item, idx) => (
                            <tr key={idx}>
                                <td>{idx + 1}</td>
                                <td>{item?.label || 'Not filled'}</td>
                                <td>{item?.value || 'Not filled'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default VillageList
